import FeatureTable from "@arcgis/core/widgets/FeatureTable.js";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import TableToolbarComponent from "./TableToolbarComponent";
import { queries_state, addCreatedTableId } from "../../../../features/queries/queriesSlice";

const TableResultComponent = forwardRef(({ tableSize, id, mapDiv, mapView, mapLayer, sublayer, featureLayer, graphicLayer }, ref) => {

    const tableRef = useRef(null);

    const [uid, setUid] = useState(id);
    const [featureTable, setFeatureTable] = useState(null);

    const dispatch = useDispatch();
    const queriesState = useSelector(queries_state);

    const hiddenAttributes = ["OBJECTID", "SHAPE"];


    //estos deben ser los nombres de las columnas de la tabla
    const [columnValues, setColumnValues] = useState([]);

    /**
     * Funcion para obtener los nombres de las columnas de la tabla de atributos
     */
    const getColumnNames = () => {
        let columnNamesCopy = [];
        featureLayer.fields.forEach((field) => {
            if (!hiddenAttributes.includes(field.name)) {
                const columnValues = {
                    "name": field.name,
                    "alias": field.alias
                }
                columnNamesCopy.push(columnValues)
            }
        });
        //console.log('column names', columnNamesCopy)
        setColumnValues(columnNamesCopy);
    }
    /*
    const getField = (name) => {
        let out = null;
        for (let field of fields) {
            if (field.name == name) {
                out = field;
            }
        }
        return out;
    }*/
    /*
    const getTableFields = () => {
        let out = [];
        out.push({
            title: i18next.t('common.actions'),
            dataIndex: "_table_actions",
        });
        let keys =  Object.keys(features[0].attributes);
        keys.map((key, i) => {
            if (!hiddenAttributes.includes(key)) {
                let field = getField(key);
                if (field != null) {
                    out.push({
                        title: field.alias,
                        dataIndex: key,
                    });
                }
                else {
                    out.push({
                        title: key,
                        dataIndex: key,
                    });
                }
            }
        })
        //console.log("getTableFields", out)
        return out;
    }*/

    useEffect(() => {
        /*if (!uid) {
            var uuid = Math.random().toString(36).slice(-6);
            setUid(uuid)
        }
        else {
            const ft = new FeatureTable({
                view: mapView, // This must be set to enable highlight in the map
                layer: featureLayer,
                hiddenFields: hiddenAttributes,
                highlightEnabled: true,
                container: uid
            });
            getColumnNames();
            setFeatureTable(ft);
        }*/

        tableRef.current.innerHTML = "";

        const ft = new FeatureTable({
            view: mapView, // This must be set to enable highlight in the map
            layer: featureLayer,
            hiddenFields: hiddenAttributes,
            highlightEnabled: true,
            container: uid,
        });

        getColumnNames();
        setFeatureTable(ft);
        //console.log('el uuid', ft.id)
        //console.log("en tabla ft", ft.layer.fields.length)
        dispatch(addCreatedTableId(ft.id))

    }, [])


    return (
        < >
            {
                featureTable &&
                <TableToolbarComponent
                    mapDiv={mapDiv}
                    mapView={mapView}
                    mapLayer={mapLayer}
                    ref={ref}
                    sublayer={sublayer}
                    featureLayer={featureLayer}
                    featureTable={featureTable}
                    graphicLayer={graphicLayer}
                    columnValues={columnValues}>
                </TableToolbarComponent>
            }
            {
                uid && <div id={uid} style={{ height: tableSize - 130 }} ref={tableRef}></div>
            }
        </>
    )
});
export default TableResultComponent;